// extracted by mini-css-extract-plugin
export default {"Emoji":"bbn_a bhp_i bhp_q bhp_j"};